import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-simple-arrow-down",
  "use": "app-icon-simple-arrow-down-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"app-icon-simple-arrow-down\"><path d=\"M14.086 6.881a.6.6 0 00-.774-.063l-.074.063-5.233 5.233L2.773 6.88a.6.6 0 00-.774-.063l-.075.063a.6.6 0 00-.063.774l.063.075 5.657 5.657a.6.6 0 00.774.063l.075-.063 5.656-5.657a.6.6 0 000-.849z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol